<article class="sign-up-form-wrapper" *ngIf="!isBanner && !errorEmail">
  <form *ngIf="!(enableSelectMethodMessage || enableValidateCode || enableSelectEmail)" [formGroup]="loginForm"
    class="sign-up-form">
    <section class="social-network-button-wrapper" *ngIf="!countryConfig.loginForm.validateHtml && !showPass">
      <app-button
        *ngIf="authActiveConfig?.facebook"
        class="class-app-button"
        [buttonId]="idPrefix + 'login-facebook'"
        [customClasses]="'facebook social full-width'"
        [isLoading]="isLoading.facebook"
        [title]="'Continuar con Facebook'"
        [isFacebook]="true"
        (click)="facebookLoginListener()"
      ></app-button>
      <app-button
        *ngIf="authActiveConfig?.google"
        class="class-app-button"
        [buttonId]="idPrefix + 'login-google'"
        [customClasses]="'google social full-width'"
        [isLoading]="isLoading.google"
        [title]="'Continuar con Google'"
        [isGoogle]="true"
        (click)="google()"
      ></app-button>
      <app-button
        *ngIf="authActiveConfig?.apple"
        class="class-app-button"
        [buttonId]="idPrefix + 'login-apple'"
        [customClasses]="'apple social full-width'"
        [isLoading]="isLoading.apple"
        [title]="'Continuar con Apple'"
        [isApple]="true" (click)="apple()"
      ></app-button>
      <app-form-divider *ngIf="!showPass && isSomeAuthActive()" [text]="'o'"></app-form-divider>
    </section>
    <section class="form-group">
      <p class="title-form">Ingresa {{ placeholder }}:</p>
      <div [ngClass]="{'number-input': showCountry, 'phone-vzla': countryConfig.loginForm.validateHtml}">
        <app-country-select *ngIf="showCountry" [idPrefix]="idPrefix + 'sign-in'"
          placeholder="Seleccione un prefijo de país" (selectedCountry)="onSelectedCountry($event)"
          [customClasses]="'login'" class="position-relative">
        </app-country-select>
        <select class="form-control" *ngIf="showCountry && countryConfig.loginForm.validateHtml" formControlName="pcode" id="login-user-pcode">
          <option *ngFor="let pcode of phonecode" [value]="pcode">{{pcode}}</option>
        </select>
        <input [id]="idPrefix + 'login-email'" type="email" class="form-control" aria-describedby="Email"
          [placeholder]="placeholder" maxlength="100" formControlName="email" (keypress)="resetSpace($event)"  (onkeyup)="resetSpace($event)" (input)="cleanSpaces($event)" autocomplete="off" />
      </div>

     <small [id]="idPrefix + 'login-email-error'" class="text-danger" *ngIf="error.email">
        {{ error.email }}
      </small>

    </section>

    <section class="passwords" *ngIf="showPass">
      <div class="form-group password-one">
        <input [id]="idPrefix + 'login-password'" [type]="inputPass ? 'password' : 'text'" class="form-control"
          aria-describedby="password" placeholder="Contraseña" [minlength]="formConfig.minPassword.toString()"
          formControlName="password" (keypress)="resetSpace($event)"  (onkeyup)="resetSpace($event)" (input)="cleanSpaces($event)" (keyup.enter)="logIn()" />

        <small [id]="idPrefix + 'login-password-error'" class="text-danger" *ngIf="error.password">
          {{ error.password }}
        </small>

        <img class="img-show-pass" (click)="inputPass = !inputPass"
          src="assets/svg/{{inputPass ? 'not-visibility' : 'eyes_login'}}.svg" alt="Contraseña">

      </div>
    </section>

    <section class="terms-link" *ngIf="showPass">
      <app-button class="class-app-button" [buttonId]="idPrefix + 'login-open-reset-password'" class="link" [title]="'¿Olvidaste la contraseña?'"
        [customClasses]="'transparent text-xs'" [isButton]="false" (click)="openSelectMethodMessage()">
      </app-button>
    </section>
   <app-error-message *ngIf="!errorEmail" [error]="errorMessage" [idPrefix]="idPrefix + 'login-'"></app-error-message>
    <section class="">
      <app-button class="class-app-button" *ngIf="!showPass" [buttonId]="idPrefix + 'login-button'" [title]="'Iniciar sesión'"
        [isDisabled]="!validNumber" [customClasses]="'main full-width sign-up-button'" [isLoading]="isLoading.email"
        (clicked)="numberLogIn()">
      </app-button>
      <app-button class="class-app-button" *ngIf="showPass" [buttonId]="idPrefix + 'login-button'" [title]="'Iniciar sesión'"
      [isDisabled]="!loginForm.valid" [customClasses]="'main full-width sign-up-button'" [isLoading]="isLoading.email"
        (clicked)="logIn()">
      </app-button>

      <p class="register-link" (click)="openSignUpForm()">
        ¿No tienes cuenta?
        <a class="link" [id]="idPrefix + 'login-open-sign-up'" >Regístrate aquí</a>
      </p>
      <p *ngIf="!countryConfig.loginForm.validateHtml" class="support-link"><a (click)="openChat()">Contacta a soporte si no puedes iniciar
          sesión</a></p>
    </section>
  </form>
  <app-register-user [error]="errorMessage" [modalStatus]="registerModal " (onSignUpRegis)="openSignUpForm()">

  </app-register-user>
  <app-select-method-message *ngIf="isModal && enableSelectMethodMessage" [customers]="customerOptions"
    [isModal]="isModal" (selectMethod)="onSelectMethod($event)" (validateCodeMode)="onValidateCodeMode($event)"
    (loggedIn)="onSuccess($event)">
  </app-select-method-message>

  <app-validate-code 
    *ngIf="isModal && enableValidateCode" 
    [from]="login" 
    [listCustomer]="list" 
    (loggedIn)="onSuccess($event)" 
    [selfCheckout]="selfCheckout"
  ></app-validate-code>

  <app-select-email *ngIf="isModal && enableSelectEmail" [listEmail]="list" [isModal]="isModal"
    (selectEmail)="onSelectEmailMode($event)" (validateCodeMode)="onValidateCodeMode($event)"
    (loggedIn)="onSuccess($event)">
  </app-select-email>

  <app-overlay [isLoading]="false"></app-overlay>
</article>

<app-basic-modal [status]="{open: loginNumberModal}" class="cont-address" [modalName]="'add_address'">
  <div class="center-spinner" *ngIf="!loginNumberSelectEmail && !loginNumberEnterCode">
    <app-spinner [isLoading]="true" medium="true"></app-spinner>
  </div>
  <app-select-email *ngIf="loginNumberSelectEmail" [listEmail]="list" [isModal]="loginNumberSelectEmail"
  (selectEmail)="onSelectEmailMode($event)" (validateCodeMode)="onValidateCodeMode($event)"
  (loggedIn)="onSuccess($event)" [showTitle]="true">
  </app-select-email>

  <app-validate-code 
    *ngIf="loginNumberEnterCode" 
    [from]="login" 
    [listCustomer]="list" 
    (loggedIn)="onSuccess($event)" 
    [selfCheckout]="selfCheckout"
  ></app-validate-code>


</app-basic-modal>

<article class="sign-up-form-wrapper banner-signup" *ngIf="isBanner">
  <form *ngIf="!(enableSelectMethodMessage || enableValidateCode || enableSelectEmail)" [formGroup]="loginForm"
  class="sign-up-form" [ngClass]="{'numLoginFrom': isBanner}">
    <section class="form-group">
      <div class="banner-flex align-baseline m-top--1">
        <div class="banner-cont-email">
          <div class="number-input">
            <app-country-select  [idPrefix]="idPrefix + 'sign-in'"
              [isBanner] = 'isBanner'
              placeholder="Seleccione un prefijo de país" (selectedCountry)="onSelectedCountry($event)"
              [customClasses]="'login banner-country'" class="position-relative">
            </app-country-select>
            <input [id]="idPrefix + 'login-email'" [ngClass]="{'numLogin': isBanner}" [type]="isBanner ? 'number' : 'email'" class="form-control input-banner" aria-describedby="Email"
              placeholder="Ingresa tu número celular" maxlength="100" formControlName="email" (keypress)="resetSpace($event)" (onkeyup)="resetSpace($event)" autocomplete="off" />
          </div>
        </div>
        <app-button class="btn-login-home" [buttonId]="idPrefix + 'login-button'" [title]="'Iniciar sesión'"
          [isDisabled]="errorMessage ? true : false"
          [customClasses]="'main full-width sign-up-button button-login-home'"
          [isLoading]="isLoading.email"
          (click)="!errorMessage ? numberLogInBanner() : '' "
          >
        </app-button>
      </div>
      <app-error-message *ngIf="errorMessage && !errorEmail" [error]="errorMessage" [idPrefix]="idPrefix + 'login-'"></app-error-message>
      <div class="banner-flex align-center cont-login-banners">
        <div *ngIf="isSomeAuthActive()" class="cont-title-redes">
          <p class="title-form-right blue-text-banner">O continúa:</p>
        </div>
        <div *ngIf="isSomeAuthActive()" class="banner-flex cont-redes-login">
          <section class="social-network-button-wrapper" *ngIf="!countryConfig.loginForm.validateHtml">
            <app-button
              *ngIf="authActiveConfig?.facebook"
              [buttonId]="idPrefix + 'login-facebook'"
              [customClasses]="'facebook social banner-btn-social'"
              [isLoading]="isLoading.facebook"
              [isFacebook]="true"
              (click)="facebookLoginListener()"
            ></app-button>
            <app-button
              *ngIf="authActiveConfig?.google"
              [buttonId]="idPrefix + 'login-google'"
              [customClasses]="'google social banner-btn-social'"
              [isLoading]="isLoading.google"
              [isGoogle]="true"
              (click)="google()"
            ></app-button>
            <app-button
              *ngIf="authActiveConfig?.apple"
              [buttonId]="idPrefix + 'login-apple'"
              [customClasses]="'apple social banner-btn-social'"
              [isLoading]="isLoading.apple"
              [isApple]="true"
              (click)="apple()"
            ></app-button>
          </section>
        </div>
        <div class="register-banner">
          <p class="register-link-banner">
            ¿No tienes cuenta?
            <strong><a class="link" (click)="openSessionModal()" [id]="idPrefix + 'login-open-sign-up'">Regístrate aquí</a></strong>
          </p>
        </div>
      </div>
    </section>
  </form>
</article>
<app-overlay [isLoading]="toggleLoading"></app-overlay>

<article class="modal-error-email" *ngIf="errorEmail">
  <div class="box-error-email" *ngIf="!enableValidateCode && !isBanner">
    <h3 *ngIf="errorEmail.origin">Anteriormente ya te habías <br>registrado
      {{ (errorEmail.origin === 'Email') ? 'con correo electrónico' : 'con ' + errorEmail.origin }}
    </h3>
    <h3 *ngIf="!errorEmail.origin">
      {{ errorEmail.message }}
    </h3>
    <p *ngIf="errorEmail.origin"><span>{{errorEmail?.email}}</span></p>
    <ng-container *ngIf="showGmailIfErrorEmail()">
      <button class="btn google" (click)="google()">
        <img src="./assets/svg/google-ico.svg" alt=" Inicio de sesión con Google">
        <p>Continuar con Google</p>
      </button>
    </ng-container>
    <ng-container *ngIf="showFacebookIfErrorEmail()">
      <button class="btn facebook" (click)="facebook()">
        <img src="./assets/svg/facebook-ico.svg" alt=" Inicio de sesión con Facebook">
        <p>Continuar con Facebook</p>
      </button>
    </ng-container>
    <ng-container *ngIf="showAppleIfErrorEmail()">
      <button class="btn apple" (click)="apple()">
        <img src="./assets/svg/apple-ico.svg" alt=" Inicio de sesión con Apple">
        <p>Continuar con Apple</p>
      </button>
    </ng-container>
    <ng-container *ngIf=" errorEmail.origin === 'Email' || !errorEmail.origin ">
      <button class="btn google" (click)="email()">
        <img src="./assets/svg/email.svg" alt=" Inicio de sesión con email">
        <p>Continuar con correo electrónico</p>
      </button>
    </ng-container>
    <div class="divider">
      <app-form-divider [text]="'o'"></app-form-divider>
    </div>
    <h3>También puedes iniciar sesión <br> con tu número celular:</h3>

    <form *ngIf="!(enableSelectMethodMessage || enableValidateCode || enableSelectEmail)" [formGroup]="loginForm"
      class="sign-up-form">

      <section class="form-group">

        <div class="banner-cont-email">
          <div class="number-input">
            <app-country-select  [idPrefix]="idPrefix + 'sign-in'"
              placeholder="Seleccione un prefijo de país" (selectedCountry)="onSelectedCountry($event)"
              [customClasses]="'login banner-country'" class="position-relative">
            </app-country-select>
            <input [id]="idPrefix + 'login-email'" [ngClass]="{'numLogin': isBanner}" [type]="errorEmail ? 'number' : 'email'" class="form-control input-banner" aria-describedby="Email"
              placeholder="Ingresa tu número" maxlength="100" formControlName="email" (keypress)="resetSpace($event)" (onkeyup)="resetSpace($event)" autocomplete="off" />
          </div>
        </div>

       <small [id]="idPrefix + 'login-email-error'" class="text-danger" *ngIf="error.email">
          {{ error.email }}
        </small>

      </section>

      <section class="terms-link" *ngIf="showPass">
        <app-button class="class-app-button" [buttonId]="idPrefix + 'login-open-reset-password'" class="link" [title]="'¿Olvidaste la contraseña?'"
          [customClasses]="'transparent text-xs'" [isButton]="false" (click)="openSelectMethodMessage()">
        </app-button>
      </section>
     <app-error-message [error]="errorMessage" [idPrefix]="idPrefix + 'login-'"></app-error-message>
      <section class="">
        <app-button class="class-app-button" *ngIf="!showPass" [buttonId]="idPrefix + 'login-button'" [title]="'Iniciar sesión'"
          [isDisabled]="!validNumber" [customClasses]="'main full-width sign-up-button'" [isLoading]="isLoading.email"
          (click)="numberLogIn()">
        </app-button>
        <app-button class="class-app-button" *ngIf="showPass" [buttonId]="idPrefix + 'login-button'" [title]="'Iniciar sesión'"
          [isDisabled]="!loginForm.valid" [customClasses]="'main full-width sign-up-button'" [isLoading]="isLoading.email"
          (click)="logIn()">
        </app-button>
      </section>
    </form>
  </div>

  <app-validate-code *ngIf="isModal && enableValidateCode" [from]="login" [listCustomer]="list" (loggedIn)="onSuccess($event)">
  </app-validate-code>

</article>
